<style lang="sass" rel="stylesheet/sass">
    @import ~bi/utilities
    @import ~bi/brand/variables
    @import ~components/swiper/swiperUpgrade
</style>

<template>
    <Swiper :options="swiperOption" ref="vpSwiper">
        <template v-if="hasButtonsOnMobile">
            <div class="swiper-button-prev" slot="button-prev" aria-hidden="true" />
            <div class="swiper-button-next" slot="button-next" aria-hidden="true" />
            <div class="swiper-pagination" slot="pagination" aria-hidden="true" />
        </template>
        <slot></slot>
        <Slide v-for="(data, index) in swiperSlides" :key="index">
            <component
                :is="component"
                :data="data"
                :index="index" />
        </Slide>
    </Swiper>
</template>

<script>
import Vue from 'vue'
import Slide from 'components/swiper/Slide'

export default {
    name: 'SwiperFactory',
    props: ['swiperSlides', 'swiperOption', 'component', 'showButtonsOnMobile'],
    components: {
        Slide
    },
    computed: {
        hasButtonsOnMobile () {
            return !this.$breakpoint.isS || (this.$breakpoint.isS && this.showButtonsOnMobile)
        },
        swiper () {
            return this.$refs.vpSwiper.swiper
        }
    },
    beforeCreate () {
        Vue.component('Swiper', () => import(/* webpackChunkName: "Swiper" */ 'components/swiper/Swiper').then(m => m.default))
    }
}
</script>
